import { render, staticRenderFns } from "./CampaignItemIsPaused.vue?vue&type=template&id=7216dc94&scoped=true&"
import script from "./CampaignItemIsPaused.vue?vue&type=script&lang=js&"
export * from "./CampaignItemIsPaused.vue?vue&type=script&lang=js&"
import style0 from "./CampaignItemIsPaused.vue?vue&type=style&index=0&id=7216dc94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7216dc94",
  null
  
)

export default component.exports